(() => {
  function setupDocuments(root = document) {
    root.querySelectorAll('[data-dh-prose]').forEach(prose => {
      if (prose.dataset.dhReady) return;
      prose.dataset.dhReady = 'true';
      const headings = Array.from(prose.querySelectorAll('h2, h3')).filter(heading => heading.textContent.trim());
      if (headings.length < 3) return;
      let layout = prose.closest('[data-dh-document]');
      if (!layout && document.body.classList.contains('dh-document-page')) {
        layout = document.createElement('div');
        layout.className = 'dh-prose-layout';
        layout.dataset.dhDocument = '';
        prose.before(layout);
        layout.append(prose);
      }
      if (!layout) return;
      let nav = layout.querySelector('.dh-page-toc');
      if (!nav) {
        nav = document.createElement('nav');
        nav.className = 'dh-page-toc';
        nav.setAttribute('aria-label', document.documentElement.lang === 'da' ? 'Indhold' : 'Contents');
        const label = document.createElement('p');
        label.className = 'dh-page-eyebrow';
        label.textContent = nav.getAttribute('aria-label');
        nav.append(label, document.createElement('ol'));
        layout.prepend(nav);
      }
      const list = nav.querySelector('ol');
      list.replaceChildren();
      const sectionId = prose.closest('.shopify-section')?.id || 'dh-page';
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${sectionId}-topic-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      nav.hidden = false;
      layout.classList.add('dh-prose-layout--with-toc');
    });
  }
  setupDocuments();
  document.addEventListener('shopify:section:load', event => setupDocuments(event.target));
})();
